import { render, staticRenderFns } from "./StatusDialogOrderDetails.vue?vue&type=template&id=218d00c4"
import script from "./StatusDialogOrderDetails.vue?vue&type=script&lang=js"
export * from "./StatusDialogOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./StatusDialogOrderDetails.vue?vue&type=style&index=0&id=218d00c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports